import React, { useEffect, useState } from "react";
import { useInView } from 'react-intersection-observer';
import { motion } from "motion/react";

import ProjectCard from "../components/project-card";
import projectImage1 from "../assets/project-cards-01.jpg";
import projectImage2 from "../assets/project-cards-02.jpg";
import projectImage3 from "../assets/project-cards-03.jpg";
import projectImage4 from "../assets/project-cards-04.jpg";

const ProjectSection = () => {
    const [isMobile, setIsMobile] = useState(false);
  
    // Check the screen size on mount
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Tailwind's 'md' breakpoint
      };
      handleResize(); // Set initial value
      window.addEventListener("resize", handleResize);
  
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    const projectCards = [
      {
        image: projectImage1,
        title: "Leightons",
        date: "2024 - 2025",
        description: "Digital and printed marketing material",
        route: "/leightons",
      },
      {
        image: projectImage3,
        title: "Kane FM",
        date: "2023 - 2025",
        description: "Social media content creator and manager",
        route: "/kane-fm",
      },
      {
        image: projectImage2,
        title: "Archer Arts",
        date: "2023 - 2025",
        description: "Brand and website design",
        route: "/archer-arts",
      },
      {
        image: projectImage4,
        title: "Powerhouse",
        date: "2021 - 2023",
        description: "Graphic design and advertising",
        route: "/powerhouse",
      }
    ];
  
    const { inView, ref } = useInView({
      triggerOnce: true,
      threshold: 0.4,
    });
  
    return (
      <div ref={ref}>
        {isMobile ? (
          // Render static content for mobile devices
          <div className="container mx-auto px-4 lg:px-8 py-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {projectCards.map((card, index) => (
                <div key={index}>
                  <ProjectCard
                    image={card.image}
                    title={card.title}
                    date={card.date}
                    description={card.description}
                    route={card.route}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          // Render animation for medium and above breakpoints
          <motion.div
            className="container mx-auto px-4 lg:px-8 py-10"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{
              hidden: { opacity: 0, scale: 0.9 },
              visible: {
                opacity: 1,
                scale: 1,
                transition: {
                  delayChildren: 0.3,
                  staggerChildren: 0.4,
                },
              },
            }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {projectCards.map((card, index) => (
                <motion.div
                  key={index}
                  variants={{
                    hidden: { opacity: 0, y: 50 },
                    visible: { opacity: 1, y: 0 },
                  }}
                >
                  <ProjectCard
                    image={card.image}
                    title={card.title}
                    date={card.date}
                    description={card.description}
                    route={card.route}
                  />
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    );
  };

  export default ProjectSection;